import { useTranslations } from '@vocab/react';
import { Loader, Text } from 'braid-design-system';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { WORKTYPES } from 'src/components/Router';
import { NEXT_ROLE_WORK_TYPE_FORM } from 'src/context/FormContext';

import { NextRoleDetail } from '../../ReadNextRole/NextRoleDetail/NextRoleDetail';
import { NextRoleSection } from '../../types';
import { EditWorkTypes } from '../EditWorkTypes/EditWorkTypes';
import { useWorkTypeOptions, useWorkTypes } from '../data';

import translations from './.vocab';

export const ReadWorkTypes = () => {
  const { t } = useTranslations(translations);
  const { workTypes, error } = useWorkTypes();
  const { getSelectedWorkTypeLabel } = useWorkTypeOptions();
  const workTypeLabels = workTypes.map((item) =>
    getSelectedWorkTypeLabel(item),
  );
  const formattedWorkTypes = workTypeLabels.join(', ');

  return (
    <>
      <NextRoleDetail
        title={t('Preferred work types')}
        section={NextRoleSection.workTypes}
      >
        {error ? (
          <Loader data={{ automation: 'work-types-loading' }} />
        ) : (
          workTypeLabels.length > 0 && <Text>{formattedWorkTypes}</Text>
        )}
      </NextRoleDetail>
      <FormDrawer
        title={t('Preferred work types')}
        component={EditWorkTypes}
        card={WORKTYPES}
        formName={NEXT_ROLE_WORK_TYPE_FORM}
      />
    </>
  );
};
